import { makeAutoObservable, toJS } from 'mobx';

export class BulkIndicatorStore {
  constructor() {
    makeAutoObservable(this);
  }

  selectedCommodity = '';

  selectedQltyCtrlSeq = null;

  selectedBulkIndicator = {};

  get getSelectedCommodity() {
    return toJS(this.selectedCommodity);
  }

  setSelectedCommodity(selectedCommodity) {
    this.selectedCommodity = selectedCommodity;
  }

  get getSelectedBulkIndicator() {
    return toJS(this.selectedBulkIndicator);
  }

  setSelectedBulkIndicator(selectedBulkIndicator) {
    this.selectedBulkIndicator = selectedBulkIndicator;
  }

  get getSelectedQltyCtrlSeq() {
    return toJS(this.selectedQltyCtrlSeq);
  }

  setSelectedQltyCtrlSeq(selectedQltyCtrlSeq) {
    this.selectedQltyCtrlSeq = selectedQltyCtrlSeq;
  }
}
